export enum PaymentType {
  Cash = "cash",
  Credit = "credit",
  Bkash = "bkash",
  Nogod = "nogod",
}
